import { render, staticRenderFns } from "./RegistrarPontoEmpresa.vue?vue&type=template&id=851cf0b0"
import script from "./RegistrarPontoEmpresa.vue?vue&type=script&lang=js"
export * from "./RegistrarPontoEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports